var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconStory(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 31.057,
    height: 25.12,
    viewBox: "0 0 31.057 25.12",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ICON",
    transform: "translate(0 -28.39)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_134",
    "data-name": "Group 134",
    transform: "translate(0 28.39)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_164",
    "data-name": "Path 164",
    d: "M30.015,31.786H27.838V29.533A1.042,1.042,0,0,0,26.95,28.5a16,16,0,0,0-4.764.143,10.7,10.7,0,0,0-6.658,3.727,10.7,10.7,0,0,0-6.658-3.727A16.007,16.007,0,0,0,4.107,28.5a1.042,1.042,0,0,0-.888,1.031v2.254H1.042A1.042,1.042,0,0,0,0,32.829V52.467a1.042,1.042,0,0,0,1.385.984c.078-.027,7.888-2.692,13.711-.036a1.042,1.042,0,0,0,.865,0c5.807-2.649,13.633.009,13.711.036a1.042,1.042,0,0,0,1.385-.984V32.829A1.042,1.042,0,0,0,30.015,31.786ZM2.084,51.073v-17.2H3.219V47.75a1.043,1.043,0,0,0,1.195,1.031c.058-.008,4.585-.63,7.893,1.64A25.374,25.374,0,0,0,2.084,51.073Zm12.4-1.592a11.23,11.23,0,0,0-5.616-2.618,16.355,16.355,0,0,0-2.9-.256c-.24,0-.462.005-.662.013V30.49h0c2-.09,6.876.124,9.183,4.035Zm2.084-14.955c2.3-3.894,7.179-4.118,9.183-4.032V46.62a16.521,16.521,0,0,0-3.567.243,11.229,11.229,0,0,0-5.616,2.618V34.525Zm2.176,15.9c3.308-2.271,7.838-1.649,7.894-1.64a1.042,1.042,0,0,0,1.2-1.031V33.871h1.135v17.2A25.368,25.368,0,0,0,18.747,50.421Z",
    transform: "translate(0 -28.39)",
    fill: "#fff"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconStory);
export default __webpack_public_path__ + "static/media/icon-story.190aa31b257d4075b0f5124ed64860bc.svg";
export { ForwardRef as ReactComponent };